import OneColumn from './OneColumn';

export default OneColumn;
